import { PermissionActions } from '@/features/permissions/permissionActions.js'
import { builderRoutes } from '@/features/settingsManagement/builder/builderRoutes.js'
import { fieldManagementRoutes } from '@/features/settingsManagement/fieldManagement/fieldManagementRoutes.js'
import { inventoryManagementRoutes } from '@/features/settingsManagement/inventoryManagement/inventoryManagementRoutes.js'
import { membershipCategoryManagementRoutes } from '@/features/settingsManagement/membershipCategoryManagement/membershipCategoryManagementRoutes.js'
import { membershipManagementRoutes } from '@/features/settingsManagement/membershipManagement/membershipManagementRoutes.js'
import { orgDisciplineManagementRoutes } from '@/features/settingsManagement/orgDisciplineManagement/orgDisciplineManagementRoutes.js'
import { personTypeManagementRoutes } from '@/features/settingsManagement/personTypeManagement/personTypeManagementRoutes.js'
import { profileManagementRoutes } from '@/features/settingsManagement/profileManagement/profileManagementRoutes.js'
import { registrationManagementRoutes } from '@/features/settingsManagement/registrationManagement/registrationManagementRoutes.js'
import { roleManagementRoutes } from '@/features/settingsManagement/roleManagement/roleManagementRoutes.js'
import { termManagementRoutes } from '@/features/settingsManagement/termManagement/termManagementRoutes.js'

export const settingsManagementRoutes = [
  {
    path: 'settings',
    redirect: '/admin/settings/main',
    component: () => import('@/features/settingsManagement/SettingsManagementView.vue'),
    meta: { permissionAction: PermissionActions.SettingsView },
    children: [
      {
        path: 'main',
        component: () => import('@/features/settingsManagement/main/SettingsMainView.vue'),
        meta: { permissionAction: PermissionActions.SettingsMainView },
      },
      ...fieldManagementRoutes,
      ...builderRoutes,
      ...registrationManagementRoutes,
      ...termManagementRoutes,
      ...membershipManagementRoutes,
      ...orgDisciplineManagementRoutes,
      ...membershipCategoryManagementRoutes,
      ...inventoryManagementRoutes,
      ...personTypeManagementRoutes,
      ...roleManagementRoutes,
      ...profileManagementRoutes,
    ],
  },
]
